import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import { Toast } from 'vant'
import getSignature from '@/utils/signature'
// var isLoading = false
// import store from '@/store'
// import qs from 'querystringify'
const whiteList = ['/api/file/getUploadId', '/api/file/upload/single']
// 取消重复请求
let pending = []
let cancelToken = axios.CancelToken
const source = cancelToken.source()
let removePending = (config) => {
  /* eslint-disable */
  for (let p in pending) {
    let configBase = ''
    if (config.url.indexOf(config.baseURL) == -1) {
      configBase = config.baseURL
    }
    // console.log(configBase, 'configBase')
    if (config.baseURL + pending[p].u === configBase + config.url + '&' + config.method) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}

let cutReq = (config) => {
  const url = config.url.startsWith('https') ? config.url : config.url
  for (let p in pending) {
    if (pending[p].u === url + '&' + config.method) {
      return true
    }
  }
}

// 根据开发环境定义 baseURL
let baseURL = ''
// 如果是本地 走代理
if (process.env.NODE_ENV != 'development') {
  baseURL = process.env.VUE_APP_PHP_BASE_API
}
// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  // baseURL: '', // url = base url + request url
  baseURL: baseURL, // url = base url + request url
  timeout: 10000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const { method, data, contentType, url } = config
    let flag = cutReq(config)
    if (flag === true) return null
    config.cancelToken = new cancelToken((c) => {
      const url = config.url.startsWith('https') ? config.url : config.url
      // 如果是白名单接口 不存入pending
      for (let i = 0; i < whiteList.length; i++) {
        if (whiteList[i].indexOf(url) != -1) {
          return
        }
      }
      pending.push({ u: url + '&' + config.method, f: c })
    })
    if (url.indexOf('undefined') > -1) {
      console.log('参数错误：' + url)
      source.cancel()
      config.cancelToken = source.token
    }
    // 获得签名 signature
    var signatureObj = {}
    signatureObj = getSignature(url, method, data, config.params)
    if (process.env.NODE_ENV != 'development') {
      if (url.startsWith('/api/auth')) {
        config.baseURL = process.env.VUE_APP_PHP_BASE_API
      }
      if (url.startsWith('/api/basic') || url.startsWith('/api/creditmall')) {
        config.baseURL = process.env.VUE_APP_PHP_BASE_API
      }
      if (url.startsWith('/api/xgzj')) {
        config.baseURL = process.env.VUE_APP_XGZJ
      }
      if (url.startsWith('/user-proxy/')) {
        config.baseURL = process.env.VUE_APP_XINGJIAN_API
      }
    }
    // parse data
    if (contentType === 'json') {
      config.headers['Content-Type'] = 'application/json'
    } else if (method !== 'get' && _.isObject(data)) {
      if (typeof config.headers['Content-Type'] === 'undefined') {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        // config.data = qs.stringify(data)
      }
    }
    if (method == 'get' && config.params) {
      // config.data = Object.assign(config.params, signatureObj)
      config.params = Object.assign(config.params, signatureObj)
    } else {
      console.log(222)
      config.params = signatureObj
    }
    // 签名标识头
    config.headers['X-Terminal'] = 'Wap'
    // if (store.getters.token) {
    if (sessionStorage.getItem('X-Authorization')) {
      config.headers['X-Authorization'] = 'Bearer ' + sessionStorage.getItem('X-Authorization')
    }
    // 这里是证件需要的请求头
    if (sessionStorage.getItem('Authorization')) {
      config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('Authorization')
    }
    // }
    return config
  },
  (error) => {
    // do something with request error
    console.log('---error---')
    console.log(error) // for debug
    pending = []
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    console.log(res, 'axios response...')
    removePending(response.config)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      // 授权认证----token失效独有code
      if (res.code == 60301) {
        return Promise.reject(res)
      }
      if (res.code == 411 || res.code == 412) {
        sessionStorage.removeItem('X-Authorization')
        sessionStorage.removeItem('Authorization')
        // to re-login
        window.GSApi.user.logout((val) => {
          console.log('axios response登录返回', val)
          // 登录成功
          // if (val == -1 || val == 1) {
          //   sessionStorage.setItem('X-Authorization', val)
          //   sessionStorage.setItem('Authorization', val)
          //   location.reload()
          // } else {
          //   setTimeout(() => {
          //     window.GSApi.back()
          //   }, 1000)
          // }
        })
      }
      // // 512: 我的证照--未查到证件信息
      // // 4006: 核酸检测不成功(人数已满、过时等)
      // // 466: 核酸检测没有可预约时间段
      // if (res.code == 512 || res.code == 4006 || res.code == 466) {
      //   return res
      // }
      // // 预约黑名单
      // if (res.code == 10010) {
      //   return res
      // }
      // 弹出错误提示
      Toast(res.msg)
      return Promise.reject(res)
    } else {
      return res.data
    }
  },
  (error) => {
    console.log('000000')
    console.log('超时异常error')
    console.log('err： ' + error)
    pending = []
    // isLoading = false
    return Promise.reject(error)
  }
)
Vue.$request = service
export default service
